import { post } from '../utils/http';
import { APIResponse } from '../types/api-response';
import { InviteUserItem } from '../types/inviteuser-item';

export function inviteUsers(token: string, orgId: string, users: InviteUserItem[]): Promise<APIResponse>  {
  return post('1.0/admin/inviteusers', { token, orgId, users });
}